import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { Auth0Provider } from '@auth0/auth0-react';
import { ToastContainer } from 'react-toastify';
import '@ionic/react/css/core.css';
import { setupIonicReact } from '@ionic/react';

setupIonicReact();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ToastContainer />
    <Auth0Provider
      domain={`${import.meta.env.VITE_REACT_AUTH0_DOMAIN}`}
      clientId={`${import.meta.env.VITE_REACT_AUTH0_CLIENT_ID}`}
      redirectUri={window.location.origin}
      audience={`${import.meta.env.VITE_REACT_AUTH0_AUDIENCE}`}
      useRefreshTokens={true}
      cacheLocation="localstorage" // Uncomment if needed
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>,
);
